<div class="app-container">
  <header>
    <app-header [showNavToggle]="false" [showBreadcrumb]="false">
      <app-notification-bell header-extra-actions />
    </app-header>
  </header>
  <main>
    <div class="app-page-content">
      @if (showBackToHome()) {
        <div class="page-back-nav">
          <button class="page-back-nav__btn" type="button" (click)="navigateHome()">
            <i class="fas fa-arrow-left page-back-nav__icon"></i>
            <span>Back to Home</span>
          </button>
        </div>
      }
      <router-outlet></router-outlet>
    </div>
  </main>
  <footer>
    <p>{{ 'footer.rights' | transloco }}</p>
  </footer>
</div>

<!-- Dev-only role impersonator panel (localhost only) -->
<app-role-impersonator />

<!-- "Getting Started" interactive tour spotlight (rendered once, globally) -->
<app-tour-overlay />
